import * as React from 'react';
import TextField from "@material-ui/core/TextField";
import { RegionFilterSettingsModel } from "../../../models/region/regionFilterSettingsModel";
import Translate from '../../../common/functions/translate';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faTimes } from '@fortawesome/free-solid-svg-icons';
import Paper from '@material-ui/core/Paper';

interface IProps {
  onSearchClick: any,
  totalRecordsCount: number
}

interface IState {
  regionSettings: RegionFilterSettingsModel,
  filterText: string,
}

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        width: 200
      }
    }
  },
  palette: {
    primary: blue
  }
});

export class RegionFilter extends React.Component<IProps, IState>  {
  constructor(props) {
    super(props);
    this.state = {
      regionSettings: new RegionFilterSettingsModel(),
      filterText: '',
    };
  }

  componentDidMount() {

  }

  handleChange = (key, value) => {

    const regionSettings: RegionFilterSettingsModel = { ...this.state.regionSettings };
    regionSettings[key] = value;
    const fiterText = this.generateFilterText(regionSettings);
    this.setState({ regionSettings: { ...regionSettings }, filterText: fiterText });
  };

  generateFilterText = (settings: RegionFilterSettingsModel) => {
    let result = '';

    if (settings.name) {
      result += Translate("Region") + " <strong>'" + settings.name + "'</strong>, "
    }

    return result.substr(0, result.length - 2);
  }

  handleSearchButtonClick = (settings) => {
    this.props.onSearchClick(settings);
  }

  handleClearButtonClick = () => {
    this.setState({
      regionSettings: new RegionFilterSettingsModel(),
      filterText: ''
    });
    this.handleSearchButtonClick(new RegionFilterSettingsModel());
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearchButtonClick(this.state.regionSettings)
    }
  }

  render() {
    return (
      <Paper style={{ padding: 10, marginBottom: 15, backgroundColor: "#f5f5f5" }} >
        <div>
          <MuiThemeProvider theme={theme}>
            <TextField
              onKeyPress={(e) => this.handleKeyPress(e)}
              name="name"
              label={Translate("Name")}
              style={{ marginRight: 10 }}
              type="text"
              onChange={(e) => this.handleChange('name', e.target['value'])}
              value={this.state.regionSettings && this.state.regionSettings.name ? this.state.regionSettings.name : ""}
            />
          </MuiThemeProvider>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 5 }}>
          <div style={{ fontSize: "0.9em" }}>
            {Translate('Result')}: <strong>{this.props.totalRecordsCount}</strong>
            {this.state.filterText ? ', ' : ''}
            <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
          </div>
          <div>
            <Button
              color="primary"
              variant="contained"
              style={{ marginRight: 10 }}
              size="small"
              onClick={() => this.handleSearchButtonClick(this.state.regionSettings)}>
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: 10 }} />
              {Translate("Filter")}
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => this.handleClearButtonClick()}>
              <FontAwesomeIcon icon={faTimes} style={{ marginRight: 10 }} />
              {Translate("Clear")}
            </Button>
          </div>
        </div>
      </Paper>
    )
  }
}

export default RegionFilter;
